import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import avatar from "../../assets/images/avatar.png";
import { userSelector } from "../../redux/authSlice";

const SurveyorInfo = () => {
  const user = useSelector(userSelector);
  return (
    <>
      <div className="surveyorCard ">
        <div className="cardbody">
          <div className="avatar">
            {/* <img src={avatar} alt="" /> */}
            {user?.firstName?.charAt(0).toUpperCase() +
              user?.lastName?.charAt(0).toUpperCase()}
          </div>
          <div className="name">{`${user?.firstName} ${user?.lastName}`}</div>
          <div className="designation">Surveyor</div>
        </div>
        {/* <div className="cardFooter">
          <Link to="#" className="btn cta-primary-light w-100">
            Edit Profile
          </Link>
        </div> */}
      </div>
    </>
  );
};

export default SurveyorInfo;
